import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAccount } from '../hooks/useAccount'

interface Props {
  children: React.ReactNode
}

/**
 * Wraps any route that requires authentication.
 * - Shows a spinner while the /auth/me check is in flight.
 * - Redirects to /login if the user is not authenticated.
 * - Renders children if authenticated.
 */
export default function ProtectedRoute({ children }: Props) {
  const { data: user, isLoading } = useAccount()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress size={48} />
      </Box>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
